var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { Image } from '../Image';
import { DivTag } from '../../Utils/AtomicTag';
import { getOffset } from '../../Utils/browser';
var ZoomImage = /** @class */ (function (_super) {
    __extends(ZoomImage, _super);
    function ZoomImage(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapEle = React.createRef();
        _this.imgLoaded = function () {
            var zoom = _this.props.zoom;
            var area = _this.wrapEle.current;
            if (!area) {
                console.warn('渲染出错');
            }
            else {
                _this.parentOffset = getOffset(area);
                var param = {
                    sourceWidth: area.offsetWidth,
                    sourceHeight: area.offsetHeight,
                    movingBlockWidth: area.offsetWidth / zoom,
                    movingBlockHeight: area.offsetHeight / zoom,
                };
                _this.cssObj = __assign(__assign({}, _this.cssObj), param);
            }
        };
        _this.changeEnterStatus = function () {
            var isEnter = _this.state.isEnter;
            if (!isEnter) {
                _this.setState({
                    isEnter: true,
                });
            }
        };
        _this.changeLeaveStatus = function () {
            var isEnter = _this.state.isEnter;
            if (isEnter) {
                _this.setState({
                    isEnter: false,
                });
            }
        };
        _this.zoomMove = function (e) {
            var movePage = getMovePage(e, _this.cssObj, _this.parentOffset);
            _this.setState({
                movePageX: movePage.x,
                movePageY: movePage.y,
            });
        };
        _this.state = {
            movePageX: 0,
            movePageY: 0,
            isEnter: false,
        };
        _this.cssObj = {
            sourceWidth: 0,
            sourceHeight: 0,
            movingBlockWidth: 0,
            movingBlockHeight: 0,
        };
        _this.parentOffset = {
            offsetTop: 0,
            offsetLeft: 0,
        };
        return _this;
    }
    ZoomImage.prototype.render = function () {
        var _a = this.props, src = _a.src, zoom = _a.zoom, className = _a.className, bigImgBoxCls = _a.bigImgBoxCls, zoomSrc = _a.zoomSrc, rest = __rest(_a, ["src", "zoom", "className", "bigImgBoxCls", "zoomSrc"]);
        var _b = this.state, movePageX = _b.movePageX, movePageY = _b.movePageY, isEnter = _b.isEnter;
        var _c = this.cssObj, movingBlockWidth = _c.movingBlockWidth, movingBlockHeight = _c.movingBlockHeight, sourceHeight = _c.sourceHeight, sourceWidth = _c.sourceWidth;
        var ZoomImageStyle = {
            position: 'absolute',
            minWidth: zoom * sourceWidth + "px",
            top: -movePageY * zoom + "px",
            left: -movePageX * zoom + "px",
        };
        var zoomAreaStyle = {
            width: movingBlockWidth + "px",
            height: movingBlockHeight + "px",
            top: movePageY + "px",
            left: movePageX + "px",
        };
        var boxCls = ['relative', 'p-2', 'border'];
        var zoomImgCls = isEnter ? 'visible' : 'invisible';
        var bigImgBoxsCls = [
            'box-border',
            'absolute',
            'w-full',
            'h-full',
            'top-0',
            'border',
            'overflow-hidden',
            zoomImgCls,
        ];
        var moveareaCls = [
            'absolute',
            'z-30',
            'w-full',
            'h-full',
            'top-0',
            'left-0',
        ];
        var zoomAreaCls = ['absolute', 'z-20', 'bg-black', 'opacity-40'];
        return (React.createElement(DivTag, __assign({ atomics: boxCls }, rest, { ref: this.wrapEle }),
            React.createElement(DivTag, { atomics: moveareaCls, onMouseEnter: this.changeEnterStatus, onMouseLeave: this.changeLeaveStatus, onMouseMove: this.zoomMove }),
            src && React.createElement(Image, { src: src, onLoad: this.imgLoaded }),
            isEnter && React.createElement(DivTag, { atomics: zoomAreaCls, style: zoomAreaStyle }),
            !!zoomSrc && (React.createElement(DivTag, { atomics: bigImgBoxsCls, className: bigImgBoxCls, style: { left: '101%' } },
                React.createElement(Image, { style: ZoomImageStyle, src: zoomSrc, width: zoom * sourceWidth, height: zoom * sourceHeight })))));
    };
    ZoomImage.defaultProps = defaultProps;
    ZoomImage.NAME = 'zoom-image';
    return ZoomImage;
}(PureComponent));
export { ZoomImage };
var getMovePage = function (e, cssObj, parentOffset) {
    var movingBlockWidth = cssObj.movingBlockWidth, movingBlockHeight = cssObj.movingBlockHeight, sourceWidth = cssObj.sourceWidth, sourceHeight = cssObj.sourceHeight;
    var scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft;
    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    var x = e.clientX + scrollLeft - parentOffset.offsetLeft - movingBlockWidth / 2;
    var disX = sourceWidth - movingBlockWidth;
    x = x < 0 ? 0 : x > disX ? disX : x;
    var y = e.clientY + scrollTop - parentOffset.offsetTop - movingBlockHeight / 2;
    var disY = sourceHeight - movingBlockHeight;
    y = y < 0 ? 0 : y > disY ? disY : y;
    return {
        x: x,
        y: y,
    };
};
